import { DealerSelect } from '@/features/dealers/components/DealerSelect';
import { useDealersByIds } from '@/features/dealers/hooks/useDealersByIds';
import type { Dealer } from '@/features/dealers/types/dealers.types';

interface Props {
  id?: string;
  value: string | null;
  onChange: (dealerId: string | null) => void;
  placeholder?: string;
}

const toSelectedDealer = (id: string, name: string): Dealer => ({ id, name, dealer_code: '' }) as Dealer;

export function DealerOwnerSelect({ id, value, onChange, placeholder }: Props) {
  const { data } = useDealersByIds(value ? [value] : []);
  const name = data?.find((dealer) => dealer.id === value)?.name ?? value;

  return (
    <DealerSelect
      id={id}
      selected={value && name ? toSelectedDealer(value, name) : null}
      onSelect={(dealer) => onChange(dealer?.id ?? null)}
      placeholder={placeholder}
    />
  );
}
